<template>
    <div
        class="card-challenge-list-item-completed"
        :class="expansionClass">
        <div class="wr-card-challenge-list-item-completed__users">
            <div class="card-challenge-list-item-completed__user1">
                <div class="wr-card-challenge-list-item-completed__user1">
                    <img
                        :src="userImageLink1"
                        class="card-challenge-list-item-completed__user-img"/>
                    <span class="card-challenge-list-item-completed__username">{{ username1 }}</span>
                    <div
                        class="card-challenge-list-item-completed__user-result"
                        :class="resultClass1">
                        <span class="card-challenge-list-item-completed__user-result-icon"></span>
                        <span class="card-challenge-list-item-completed__user-result-text">{{ resultText1 }}</span>
                    </div>
                </div>
            </div>
            <div class="card-challenge-list-item-completed__user2">
                <div class="wr-card-challenge-list-item-completed__user2">
                    <img
                        :src="userImageLink2"
                        class="card-challenge-list-item-completed__user-img"/>
                    <span class="card-challenge-list-item-completed__username">{{ username2 }}</span>
                    <div
                        class="card-challenge-list-item-completed__user-result"
                        :class="resultClass2">
                        <span class="card-challenge-list-item-completed__user-result-icon"></span>
                        <span class="card-challenge-list-item-completed__user-result-text">{{ resultText2 }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-challenge-list-item-completed__stats">
            <div class="card-challenge-list-item-completed__stat-category
                        card-challenge-list-item-completed__stat-correctness">
                <span
                    class="card-challenge-list-item-completed__stat-value
                           card-challenge-list-item-completed__stat-value-user1"
                    :class="resultClass1">%{{ challengeItem.stats.correctness.user1 }}</span>
                <span class="card-challenge-list-item-completed__stat-label">DOĞRULUK</span>
                <span
                    class="card-challenge-list-item-completed__stat-value
                           card-challenge-list-item-completed__stat-value-user2"
                    :class="resultClass2">%{{ challengeItem.stats.correctness.user2 }}</span>
            </div>

            <div class="card-challenge-list-item-completed__stat-category
                        card-challenge-list-item-completed__stat-correct">
                <span
                    class="card-challenge-list-item-completed__stat-value
                           card-challenge-list-item-completed__stat-value-user1"
                    :class="resultClass1">{{ challengeItem.stats.correct.user1 }}</span>
                <span class="card-challenge-list-item-completed__stat-label">DOĞRU</span>
                <span
                    class="card-challenge-list-item-completed__stat-value
                           card-challenge-list-item-completed__stat-value-user2"
                    :class="resultClass2">{{ challengeItem.stats.correct.user2 }}</span>
            </div>

            <div class="card-challenge-list-item-completed__stat-category
                        card-challenge-list-item-completed__stat-incorrect">
                <span
                    class="card-challenge-list-item-completed__stat-value
                           card-challenge-list-item-completed__stat-value-user1"
                    :class="resultClass1">{{ challengeItem.stats.incorrect.user1 }}</span>
                <span class="card-challenge-list-item-completed__stat-label">YANLIŞ</span>
                <span
                    class="card-challenge-list-item-completed__stat-value
                           card-challenge-list-item-completed__stat-value-user2"
                    :class="resultClass2">{{ challengeItem.stats.incorrect.user2 }}</span>
            </div>

            <div class="card-challenge-list-item-completed__stat-category
                        card-challenge-list-item-completed__stat-skipped">
                <span
                    class="card-challenge-list-item-completed__stat-value
                           card-challenge-list-item-completed__stat-value-user1"
                    :class="resultClass1">{{ challengeItem.stats.skipped.user1 }}</span>
                <span class="card-challenge-list-item-completed__stat-label">GEÇİLEN</span>
                <span
                    class="card-challenge-list-item-completed__stat-value
                           card-challenge-list-item-completed__stat-value-user2"
                    :class="resultClass2">{{ challengeItem.stats.skipped.user2 }}</span>
            </div>
        </div>
        <button
            class="btn-expand-stats"
            @click="expandStats">
            <span class="btn-expand-stats__icon"></span>
        </button>
        <div class="card-challenge-list-item-completed__separator">
            <span class="card-challenge-list-item-completed__separator-icon"></span>
            <span class="card-challenge-list-item-completed__separator-text">VS</span>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            challengeItem: {
                type: Object,
                default: {
                    id: 9,
                    status: "COMPLETED",
                    user1: {
                        id: 2,
                        username: "testuser101214",
                        status: "DONE-PRACTICE"
                    },
                    user2: {
                        id: 1,
                        username: "temren",
                        status: "DONE-PRACTICE"
                    },
                    results: {
                        draw: false,
                        user1: "winner",
                        user2: "loser"
                    },
                    stats: {
                        correctness: {
                            user1: 40,
                            user2: 10
                        },
                        correct: {
                            user1: 15,
                            user2: 12
                        },
                        incorrect: {
                            user1: 3,
                            user2: 7
                        },
                        skipped: {
                            user1: 2,
                            user2: 1
                        }
                    }
                }
            }
        },

        data(){
            return {
                statExpansion: false,
            };
        },

        computed: {
            userImageLink1(){
                // return this.$store.state.api.img + this.challengeItem.user1.id + '.jpg';
                return this.$store.state.api.getImage + this.challengeItem.user1.id;
            },

            userImageLink2(){
                // return this.$store.state.api.img + this.challengeItem.user2.id + '.jpg';
                return this.$store.state.api.getImage + this.challengeItem.user2.id;

            },

            username1(){
                let userSession = this.$store.state.userSession;
                if(userSession.id === this.challengeItem.user1.id){
                    return 'sen';
                }
                return this.challengeItem.user1.username;
            },

            username2(){
                let userSession = this.$store.state.userSession;
                if(userSession.id === this.challengeItem.user2.id){
                    return 'sen';
                }
                return this.challengeItem.user2.username;
            },

            resultClass1(){
                if(this.challengeItem.results.draw){
                    return 'card-challenge-list-item-completed__draw';
                }
                if(this.challengeItem.user1.status === 'LEFT-PRACTICE'){
                    return 'card-challenge-list-item-completed__left-practice';
                }
                return `card-challenge-list-item-completed__${this.challengeItem.results.user1}`;
            },

            resultClass2(){
                if(this.challengeItem.results.draw){
                    return 'card-challenge-list-item-completed__draw';
                }
                if(this.challengeItem.user2.status === 'LEFT-PRACTICE'){
                    return 'card-challenge-list-item-completed__left-practice';
                }
                return `card-challenge-list-item-completed__${this.challengeItem.results.user2}`;
            },

            resultText1(){
                let userSession = this.$store.state.userSession;
                if(this.challengeItem.results.draw){
                    return this.$t(`challenge.results.draw`);
                }
                if(this.challengeItem.user1.status === 'LEFT-PRACTICE' && userSession.id === this.challengeItem.user1.id){
                    return this.$t(`challenge.status.${this.challengeItem.user1.status.toLowerCase()}`) + 'N';
                }
                if(this.challengeItem.user1.status === 'LEFT-PRACTICE'){
                    return this.$t(`challenge.status.${this.challengeItem.user1.status.toLowerCase()}`);
                }
                if(userSession.id === this.challengeItem.user1.id){
                    return this.$t(`challenge.results.${this.challengeItem.results.user1}`) + 'N';
                }
                return this.$t(`challenge.results.${this.challengeItem.results.user1}`);
            },

            resultText2(){
                let userSession = this.$store.state.userSession;
                if(this.challengeItem.results.draw){
                    return this.$t(`challenge.results.draw`);
                }
                if(this.challengeItem.user2.status === 'LEFT-PRACTICE' && userSession.id === this.challengeItem.user2.id){
                    return this.$t(`challenge.status.${this.challengeItem.user2.status.toLowerCase()}`) + 'N';
                }
                if(this.challengeItem.user2.status === 'LEFT-PRACTICE'){
                    return this.$t(`challenge.status.${this.challengeItem.user2.status.toLowerCase()}`);
                }
                if(userSession.id === this.challengeItem.user2.id){
                    return this.$t(`challenge.results.${this.challengeItem.results.user2}`) + 'N';
                }
                return this.$t(`challenge.results.${this.challengeItem.results.user2}`);
            },

            expansionClass(){
                return this.statExpansion ? 'card-challenge-list-item-completed__expanded' : '';
            },

            selectedFiltertag(){
                return this.$store.state.selectedFiltertagChallengeList;
            },
        },

        watch: {
            selectedFiltertag: {
                handler(n, o){
                    this.statExpansion = false;
                },
                deep: true
            },
        },

        methods: {
            expandStats(){
                this.statExpansion = !this.statExpansion;
            }
        },
    };
</script>

<style scoped src="@/css/components/card-challenge-list-item-completed.css"></style>